// extracted by mini-css-extract-plugin
export var container = "_5f-0";
export var infoButton = "_5f-1";
export var label = "_5f-3";
export var labelExpanded = "_5f-4";
export var price = "_5f-5";
export var priceExpanded = "_5f-6";
export var title = "_5f-2";